import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const stagger = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.12 },
  },
};

const fadeUp = {
  hidden: { opacity: 0, y: 12 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: [0.25, 0.1, 0.25, 1] },
  },
};

const StoreButtons = () => {
  const navigate = useNavigate();

  const handleClick = (store) => {
    if (window.gtag) {
      window.gtag('event', 'get_app_click', {
        event_category: 'conversion',
        event_label: store,
      });
    }
    navigate('/waitlist');
  };

  return (
    <motion.div
      variants={stagger}
      initial="hidden"
      animate="show"
      className="flex flex-col sm:flex-row items-center gap-3 sm:gap-4 mt-10 sm:mt-12"
      data-testid="store-buttons-container"
    >
      {/* App Store */}
      <motion.button
        variants={fadeUp}
        onClick={() => handleClick('app_store')}
        whileHover={{ scale: 1.03 }}
        whileTap={{ scale: 0.97 }}
        className="flex items-center gap-3 bg-white/[0.05] border border-white/[0.12] rounded-xl px-5 py-3 hover:bg-white/[0.08] transition-colors w-[200px]"
        data-testid="app-store-button"
      >
        <svg viewBox="0 0 24 24" className="w-7 h-7 text-white fill-current flex-shrink-0">
          <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
        </svg>
        <div className="text-left">
          <div className="text-[10px] text-zinc-400 leading-none">Descarga en</div>
          <div className="text-white text-sm font-medium leading-tight mt-0.5">App Store</div>
        </div>
      </motion.button>

      {/* Play Store */}
      <motion.button
        variants={fadeUp}
        onClick={() => handleClick('play_store')}
        whileHover={{ scale: 1.03 }}
        whileTap={{ scale: 0.97 }}
        className="flex items-center gap-3 bg-white/[0.05] border border-white/[0.12] rounded-xl px-5 py-3 hover:bg-white/[0.08] transition-colors w-[200px]"
        data-testid="play-store-button"
      >
        <svg viewBox="0 0 24 24" className="w-7 h-7 flex-shrink-0">
          <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92z" fill="#4285F4"/>
          <path d="M17.727 8.273L5.738.573c-.453-.29-.96-.41-1.446-.37L14.5 10.412l3.227-2.14z" fill="#EA4335"/>
          <path d="M17.727 15.727L14.5 13.588 4.292 23.797c.486.04.993-.08 1.446-.37l11.989-7.7z" fill="#34A853"/>
          <path d="M21.182 12c0-.587-.313-1.14-.828-1.47l-2.627-1.257L14.5 12l3.227 2.727 2.627-1.257c.515-.33.828-.883.828-1.47z" fill="#FBBC05"/>
        </svg>
        <div className="text-left">
          <div className="text-[10px] text-zinc-400 leading-none">Descarga en</div>
          <div className="text-white text-sm font-medium leading-tight mt-0.5">Play Store</div>
        </div>
      </motion.button>
    </motion.div>
  );
};

export default StoreButtons;
